import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";

export const buttonCSS = css({
  display: "inline-flex",
  alignItems: "center",
});

const large = css({
  gap: vars.spacing["15"],
});

const medium = css({
  gap: vars.spacing[1],
});

const small = css({
  gap: vars.spacing["05"],
});

export const sizeStyles = {
  large,
  medium,
  small,
};

const primary = css({
  color: vars.semantic.color.textAccent,
  svg: {
    color: vars.semantic.color.textAccent,
  },

  "&:hover": {
    color: vars.semantic.color.textAccentHover,
    svg: {
      color: vars.semantic.color.textAccentHover,
    },
  },
});

const secondary = css({
  color: vars.semantic.color.textSecondary,
  svg: {
    color: vars.semantic.color.textSecondary,
  },

  "&:hover": {
    color: vars.semantic.color.textSecondaryHover,
    svg: {
      color: vars.semantic.color.textSecondaryHover,
    },
  },

  '&[data-imweb-loading="true"]': {
    svg: {
      color: vars.semantic.color.icon,
    },
  },
});

const critical = css({
  color: vars.semantic.color.textCritical,
  svg: {
    color: vars.semantic.color.textCritical,
  },

  "&:hover": {
    color: vars.semantic.color.textCriticalHover,
    svg: {
      color: vars.semantic.color.textCriticalHover,
    },
  },
});

const warning = css({
  color: vars.semantic.color.textWarning,
  svg: {
    color: vars.semantic.color.textWarning,
  },

  "&:hover": {
    color: vars.semantic.color.textWarningHover,
    svg: {
      color: vars.semantic.color.textWarningHover,
    },
  },
});

const on = css({
  color: vars.semantic.color.textOn,
  svg: {
    color: vars.semantic.color.textOn,
  },

  "&:hover": {
    opacity: 0.75,
  },
});

export const variantStyles = {
  primary,
  secondary,
  critical,
  warning,
  on,
};
